<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Event Note</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-danger text-center mb-3" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="form-group">
      <label for="titleInput">Title</label>
      <input type="text" class="form-control" id="titleInput" name="title" required [(ngModel)]="note.title">
      <div class="form-text text-danger">{{ errors.title }}</div>
    </div>

    <div class="form-group">
      <label for="textInput">Text (optional)</label>
      <textarea class="form-control" id="textInput" name="text" [(ngModel)]="note.text"></textarea>
      <div class="form-text text-danger">{{ errors.text }}</div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
